import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import ordersModel from "../../models/orders.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import {
  Button,
  Dropdown,
  ToggleButton,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment/moment";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Page = function () {
  const [showLoader, setShowLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
  const handleCloseAdvancedFilter = () => setShowAdvancedFilter(false);
  const handleShowAdvancedFilter = () => setShowAdvancedFilter(true);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [filterStartDate, setFilterStartDate] = useState(new Date());
 const [filterEndDate, setFilterEndDate] = useState(new Date());


  const router = useRouter();

  const queryParams = router.query;
  queryParams.order_by = queryParams.order_by ?? "created_at";
  queryParams.order_in = queryParams.order_in ?? "desc";
  queryParams.status = queryParams.status ?? "";
  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
  } = useForm();

  const {
    register: registerFilter,
    handleSubmit: handleSubmitFilter,
    formState: { errors: errorsFilter },
    setError: setErrorFilter,
  } = useForm();

  const {
    data: ordersData,
    mutate: reloadordersData,
    isLoading,
  } = useSWR(
    queryParams || null,
    () => ordersModel.list(queryParams),
    config.swrConfig
  );

  function statusFilter(status) {
    queryParams.status = status;
    queryParams.page = 1;
    router.push({ query: queryParams });
  }

  const confirmOrder = async (id) => {
    await helper.sweetalert
      .confirm(`confirm to approve Order ${id}`, "warning")
      .then(async (result) => {
        if (result.isConfirmed) {
          setShowLoader(true);
          const formData = new FormData();
          formData.append("status", "new");
          await ordersModel.update(id, formData).then((res) => {
            teamPageData();
            helper.sweetalert.toast(`Order approved Successfully`);
          });
          setShowLoader(false);
        }
      });
  };

  const cancelOrder = async (id) => {
    await ordersModel.cancel(id).then((res) => {
      helper.sweetalert.toast(res?.data?.message);
      reloadordersData();
    });
  };

  const AdmincancelOrder = async (id) => {
    await ordersModel.admincancel(id).then((res) => {
      helper.sweetalert.toast(res?.data?.message);
      reloadordersData();
    });
  };

  const replaceOrder = async (id) => {
    await ordersModel.replace(id).then((res) => {
      helper.sweetalert.toast(res?.data?.message);
      reloadordersData();
    });
  };

  const onSubmitFilter = (data) => {
  const params = {
    ...router.query,
    ...data,
    startdate: startDate ? helper.date.format(startDate, "YYYY-MM-DD") : "",
    enddate: endDate ? helper.date.format(endDate, "YYYY-MM-DD") : "",
    page: 1, // reset pagination when applying filters
  };

  router.push({ query: params }); // 🔥 this updates the URL & triggers SWR re-fetch
  handleCloseAdvancedFilter();    // close modal after saving
};

  

  const columns = [
    {
      Header: "Order Id",
      accessor: "id",
      className: "col",
      Cell: ({ row }) => {
        const remarks = row.original?.remarks || [];
      
        return (
          <span>
            {row.original.id}{" "}
            {remarks.length > 0 && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-${row.original.id}`}>
                    {remarks[0]?.remark}
                  </Tooltip>
                }
              >
                <i
                  className="bi bi-exclamation-octagon text-primary"
                  style={{ fontSize: "0.2 rem", cursor: "pointer" }}
                  onClick={() =>
                    console.log("open remarks modal for", row.original.id)
                  }
                ></i>
              </OverlayTrigger>
            )}
          </span>
        );
      },
    },

    {
      Header: "Name",
      accessor: "name",
      className: "col",
      Cell: ({ row }) => (
        <>
          {row.original.name}{" "}
          <span className="rounded-circle border p-1">
            {row.original.order_count}
          </span>
        </>
      ),
    },
    {
      Header: "Mobile",
      accessor: "mobile",
      className: "col",
    },

    {
      Header: "Items",
      className: "col",
      Cell: ({ row }) => <>{row.original.orderItem?.length}</>,
    },
    {
      Header: "Amount",
      id: "amount",
      Cell: ({ row }) => <>{helper.currency.format(row.original?.amount)}</>,
    },
    {
      Header: "City",
      id: "city",
      Cell: ({ row }) => (
        <>
          {row.original?.city}, {row.original?.state}
        </>
      ),
    },
    {
      Header: "AWB",
      id: "awb",
      Cell: ({ row }) => <>{row.original?.awb_number}</>,
    },
    {
      Header: "Payment mode",
      accessor: "payment_mode",
      className: "col",
    },

    {
      Header: "Payment Status",
      accessor: "payment_status",
      className: "col",
    },
    {
      Header: "Status",
      accessor: "status",
      className: "col",
    },
    {
      Header: "Date",
      id: "created_at",
      Cell: ({ row }) => (
        <>
          <div>{helper.date.format(row.original.created_at)}</div>
        </>
      ),
    },
    {
      className: "col-auto text-end",
      Header: "Actions",
      id: "action",
      Cell: ({ row }) => (
        <>
          <div className="btn-group btn-group-sm">
            <Link
              className="btn btn-primary"
              href={`/orders/${row.original.id}`}
            >
              <i className="bi bi-eye"></i>
            </Link>

            {/* <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.id)}
                        >
                            <i className="bi bi-trash"></i>
                        </button> */}

            <Dropdown className="btn-group btn-group-sm">
              <Dropdown.Toggle size="sm" variant="outline-primary">
                <i className="bi bi-three-dots-vertical"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {row?.original?.status == "booked" && (
                  <>
                    <Dropdown.Item onClick={() => cancelOrder(row.original.id)}>
                      <i className="bi bi-x-circle"></i> Cancel
                    </Dropdown.Item>
                  </>
                )}
                <Dropdown.Divider />
                <Dropdown.Item
                  as="button"
                  type="button"
                  className="text-primary"
                  onClick={() => AdmincancelOrder(row.original.id)}
                >
                  <i className="bi bi-arrow-repeat"></i> Admin-cancel
                </Dropdown.Item>

                <Dropdown.Divider />
                <Dropdown.Item
                  as="button"
                  type="button"
                  className="text-success"
                  onClick={() => confirmOrder(row.original.id)}
                >
                  <i className="bi bi-check2-circle"></i> Approve
                </Dropdown.Item>
                <Dropdown.Divider />

                <Dropdown.Divider />
                <Dropdown.Item
                  as="button"
                  type="button"
                  className="text-primary"
                  onClick={() => replaceOrder(row.original.id)}
                >
                  <i className="bi bi-arrow-repeat"></i> Replace
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const ExportOrders = handleSubmit(async (data, event) => {
    const formData = new FormData();

    formData.set("email", data.email);
    formData.set("start_date", helper.date.format(startDate, "DD-MM-YYYY"));
    formData.set("end_date", helper.date.format(endDate, "DD-MM-YYYY"));

    helper.sweetalert.toast(
      `Email will be sent in few minutes to ${data.email}`
    );
    await ordersModel
      .ExportOrder(formData)
      .then((response) => {
        helper.sweetalert.toast(response.message, "success");
        handleCloseModal();
      })
      .catch((error) => {
        console.log(error.response.data?.errors);
        helper.sweetalert.toast(error.response.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  return (
    <>
      <Heading title="Orders" showLoader={isLoading || showLoader}>
        {console.log()}
      </Heading>
      <div className="container-fluid">
        <div className="btn-group m-1 overflow-scroll w-100 text-nowrap">
          <ToggleButton
            key="btn-all"
            id={`radio-btn-all}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == ""}
            onChange={(e) => {
              statusFilter("");
            }}
          >
            All
          </ToggleButton>
          {/*  <ToggleButton
                        key="btn-new"
                        id={`radio-new}`}
                        type="radio"
                        variant='outline-secondary'
                        name="radio"
                        value=""
                        checked={queryParams.status == 'new'}
                        onChange={(e) => { statusFilter('new'); }}
                    >
                        New
                    </ToggleButton> */}
          <ToggleButton
            key="btn-booked"
            id={`radio-booked}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "booked"}
            onChange={(e) => {
              statusFilter("booked");
            }}
          >
            Booked
          </ToggleButton>
          <ToggleButton
            key="btn-packed"
            id={`radio-packed}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "packed"}
            onChange={(e) => {
              statusFilter("packed");
            }}
          >
            Packed
          </ToggleButton>
          <ToggleButton
            key="btn-shipped"
            id={`radio-shipped}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "shipped"}
            onChange={(e) => {
              statusFilter("shipped");
            }}
          >
            Shipped
          </ToggleButton>
          <ToggleButton
            key="btn-intransit"
            id={`radio-intransit}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "in_transit"}
            onChange={(e) => {
              statusFilter("in_transit");
            }}
          >
            In Transit
          </ToggleButton>
          <ToggleButton
            key="btn-delivered"
            id={`radio-delivered}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "delivered"}
            onChange={(e) => {
              statusFilter("delivered");
            }}
          >
            Delivered
          </ToggleButton>
          <ToggleButton
            key="btn-cancelled"
            id={`radio-cancelled}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "cancel"}
            onChange={(e) => {
              statusFilter("cancel");
            }}
          >
            Cancelled
          </ToggleButton>
          <ToggleButton
            key="btn-rto"
            id={`radio-rto}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "rto"}
            onChange={(e) => {
              statusFilter("rto");
            }}
          >
            RTO
          </ToggleButton>
          <ToggleButton
            key="btn-return"
            id={`radio-return}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "return"}
            onChange={(e) => {
              statusFilter("return");
            }}
          >
            Return
          </ToggleButton>
        </div>
        <div className="card">
          <div className="card-header">
            Orders List{" "}
            <Button className="btn btn-sm float-end ms-1" href="/orders/create">
              Create-new-order
            </Button>{" "}
            <Button className="btn btn-sm float-end" onClick={handleShowModal}>
              Export data
            </Button>
            <Button
              className="btn btn-sm float-end me-1"
              onClick={handleShowAdvancedFilter}
            >
              Advanced-filter
            </Button>
          </div>
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>Enter Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={handleSubmit} className="form-control">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className={`form-control ${errors?.email && "is-invalid"}`}
                  {...register("email", {
                    required: "Email is required",
                  })}
                />
                <div className="invalid-feedback">
                  {errors.email && errors.message}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Start-date</label>
                    <DatePicker
                      selected={startDate}
                      className="form-control"
                      dateFormat="dd-MM-YYYY"
                      onChange={(date) => setStartDate(date)}
                      name="start_date"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">End-date</label>
                    <DatePicker
                      selected={endDate}
                      className="form-control"
                      dateFormat="dd-MM-YYYY"
                      onChange={(date) => setEndDate(date)}
                      name="end_date"
                      autoComplete="off"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-sm btn-primary float-end mt-4"
                  onClick={ExportOrders}
                >
                  Generate report
                </button>
              </form>
            </Modal.Body>
          </Modal>

        <Modal show={showAdvancedFilter} onHide={handleCloseAdvancedFilter}>
  <Modal.Header>Advanced-Filter</Modal.Header>
  <Modal.Body>
    <form onSubmit={handleSubmitFilter(onSubmitFilter)} className="form-control">
      <label className="form-label">Email</label>
      <input
        type="email"
        className={`form-control ${errorsFilter?.email && "is-invalid"}`}
        {...registerFilter("email")}
      />

      <div className="row">
        <div className="col-md-6">
          <label className="form-label">Start-date</label>
          <DatePicker
            selected={startDate}
            className="form-control"
            dateFormat="dd-MM-yyyy"
            onChange={(date) => setStartDate(date)}
          />
          {/* hidden field so RHF captures it */}
          <input
            type="hidden"
            value={startDate || ""}
            {...registerFilter("startdate")}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">End-date</label>
          <DatePicker
            selected={endDate}
            className="form-control"
            dateFormat="dd-MM-yyyy"
            onChange={(date) => setEndDate(date)}
          />
          {/* hidden field so RHF captures it */}
          <input
            type="hidden"
            value={endDate || ""}
            {...registerFilter("enddate")}
          />
        </div>
      </div>

      <label className="form-label mt-2">Transaction-id</label>
      <input
        type="text"
        className={`form-control ${errorsFilter?.transaction_id && "is-invalid"}`}
        {...registerFilter("transaction_id")}
      />

      <label className="form-label mt-2">Payment Source</label>
      <select
        className={`form-control ${errorsFilter?.payment_source && "is-invalid"}`}
        {...registerFilter("payment_source")}
      >
        <option value="">-- Select Payment Source --</option>
        <option value="razorpay">Razorpay</option>
        <option value="replacement">Replacement</option>
        <option value="cod">Cod</option>
      </select>

      <button type="submit" className="btn btn-sm btn-primary float-end mt-4">
        Save
      </button>
    </form>
  </Modal.Body>
</Modal>


          <div className="table-responsive">
            <Table columns={columns} data={ordersData?.data || []} />
          </div>
          <div className="card-footer table-responsive">
            <Pagination meta={ordersData?.meta} />
          </div>
        </div>
      </div>
    </>
  );
};
export default Page;
